var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "share", class: { "share--hidden": _vm.hidden } },
    [
      _c(
        "button",
        {
          staticClass: "share__close-icon",
          on: {
            click: function ($event) {
              return _vm.toggleShareDialog()
            },
          },
        },
        [_vm._v("'")]
      ),
      _vm._v(" "),
      _c(
        "form",
        { staticClass: "share__link", attrs: { name: "share-link-form" } },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("input", {
            staticClass: "share__link-input",
            attrs: { id: "share-link", name: "share-link", type: "text" },
            domProps: { value: _vm.fullLink },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "share__link-button",
              attrs: { type: "button", title: "copy to clipboard" },
              on: {
                click: function ($event) {
                  return _vm.copyToClipboard("share-link")
                },
              },
            },
            [_vm._v("D")]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "share__email" }, [
        _vm._v("\n    Or "),
        _c(
          "a",
          {
            attrs: {
              href: _vm.mailToLink,
              "data-gtm-category": "Share",
              "data-gtm-action": "Email",
              "data-gtm-label": _vm.link,
            },
          },
          [_vm._v("send using your email client")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "label",
      { staticClass: "share__link-label", attrs: { for: "link-text" } },
      [
        _vm._v("Click on the icon or use CTRL+C"),
        _c("br"),
        _vm._v("to copy the link:"),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }